import Header from "../components/header/Header";

import React,{useEffect} from "react";
// importing aos
import AOS from 'aos';
import 'aos/dist/aos.css';

function Home() {
  useEffect(() => {
    AOS.init();
  }, [])
  
  return (
    <div data-aos="zoom-in" data-aos-duration="500">
      <Header />

      <main className="section">
        <div className="container">
          <ul className="content-list">
            <li className="content-list__item" data-aos="fade-left" data-aos-duration="500">
              <h2 className="title-2">Frontend</h2>
              <p>
                JavaScript, TypeScript, ReactJS, Angular, Redux, HTML, CSS, NPM,
                BootStrap, MaterialUI, Yarn, TailwindCSS, StyledComponents
              </p>
            </li>
            <li className="content-list__item" data-aos="fade-right" data-aos-duration="500">
              <h2 className="title-2">Backend</h2>
              <p>NodeJS, MySQL, MongoDB, PHP, Laravel</p>
            </li>
          </ul>
        </div>
      </main>
    </div>
  );
}

export default Home;
